import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CookieConsent from "../components/CookieConsent";
import WelcomeAssistant from "../components/WelcomeAssistant";

export default function Layout() {
  const [sessionUser, setSessionUser] = useState(null);
  return (
    <div className="bu-page">
      <Header onSessionChange={setSessionUser} />
      <Outlet />
      <WelcomeAssistant user={sessionUser} />
      <Footer />
      <CookieConsent />
    </div>
  );
}
